export const LOAD = 'ethstats/lastBlock/LOAD';
export const LOAD_SUCCESS = 'ethstats/lastBlock/LOAD_SUCCESS';
export const LOAD_FAIL = 'ethstats/lastBlock/LOAD_FAIL';
